<template>
  <v-container fluid>
    <div class="text-center" v-if="state === 'loading'">
      <spinner></spinner>
    </div>

    <v-form v-model="valid" v-if="state === 'signin'" ref="form" @submit.prevent="authEmail">
      <v-card-text>
        <v-text-field
            filled
            validate-on-blur
            v-model="email"
            :rules="emailRules"
            :messages="fireBaseValidationMessages"
            label="Email address"
            type="email"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" type="submit" dark >
          Sign in
        </v-btn>
      </v-card-actions>
    </v-form>

    <v-snackbar v-model="showSignInComfirmation" color="primary">
      We have send you an email.<br>
      In there you will find instructions to sign in.
    </v-snackbar>

    <div class="pt-6" v-if="state === 'drafts'">
      <v-row flat class="mb-6" color="transparent">
        <v-col>
          <img class="header-logo mr-3" src="../assets/images/logo.svg" alt="At-And logo">
          <span class="header-logo-title title">At-And: Presenter</span>
        </v-col>
        <v-col cols="1">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item key="logout" @click="signOut">
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <v-btn color="primary" class="mb-6" @click="toggleAddPresentationModal">
        Add presentation
      </v-btn>

      <v-subheader v-if="!empty">Draft presentations</v-subheader>
      <v-list subheader class="mb-3 custom" v-if="!empty">
        <template v-for="(presentation, index) in draftPresented">
          <router-link
              :key="presentation.title"
              :to="{
                name: 'view-presentation',
                params: { presentationId: presentation.presentationId }
              }"
              tag="div">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-html="presentation.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <v-divider v-if="index < draftPresented.length - 1" :key="index"></v-divider>
        </template>
      </v-list>

      <v-subheader>Presented presentations</v-subheader>
      <v-list subheader class="mb-2 custom" v-if="!empty">
        <template v-for="(presentation, index) in draftPresented">
          <router-link
              :key="presentation.title"
              :to="{
                name: 'view-presentation',
                params: { presentationId: presentation.presentationId }
              }"
              tag="div">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-html="presentation.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <v-divider v-if="index < draftPresented.length - 1" :key="index"></v-divider>
        </template>
      </v-list>
    </div>

    <v-dialog v-model="showAddPresentationModal" width="500">
      <add-presentation-modal
          @addPresentationModalClosed="closeAddPresentationModal"/>
    </v-dialog>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import { mapGetters } from 'vuex';
import spinner from '../components/Spinner';
import AddPresentationModal from '../components/AddPresentationModal';

export default {
  name: 'Presenter',

  components: {
    AddPresentationModal,
    spinner
  },

  beforeCreate() {
    this.$store.dispatch('setCurrentDraft', undefined);
  },

  created() {
    if (this.isAnonymous === true) {
      this.state = 'signin';
    } else if (this.isAnonymous === false) {
      this.state = 'drafts';
      this.$store.dispatch('getDraftPresentedPresentations');
    }
  },

  data() {
    return {
      state: 'loading',
      valid: true,
      showSignInComfirmation: false,
      showAddPresentationModal: null,
      fireBaseValidationMessages: [],
      email: '',
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ]
    };
  },

  computed: {
    empty() {
      return this.draftPresented && this.draftPresented.length === 0;
    },
    ...mapGetters([
      'userId',
      'isAnonymous',
      'draftPresented'
    ])
  },

  watch: {
    isAnonymous(val) {
      if (val) {
        this.state = 'signin';
      } else {
        this.state = 'drafts';
        this.$store.dispatch('getDraftPresentedPresentations');
      }
    }
  },

  methods: {
    setState(state) {
      this.state = state;
      this.showSignInComfirmation = true;
    },

    authEmail() {
      if (this.$refs.form.validate()) {
        const email = this.email;
        const actionCodeSettings = {
          url: `${window.location.origin}/sign-in-user?p=desktop`,
          // url: 'https://at-and.com/sign-in-user?p=desktop',
          handleCodeInApp: true
        };

        firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
          .then(() => {
            this.setState('email-send');
            window.localStorage.setItem('emailForSignIn', email);
          })
          .catch((error) => {
            this.fireBaseValidationMessages = [error.message];
          });
      }
    },

    toggleAddPresentationModal() {
      this.showAddPresentationModal = !this.showAddPresentationModal;
    },

    closeAddPresentationModal() {
      this.toggleAddPresentationModal();
    },

    signOut() {
      this.$store.dispatch('signOut');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Presenter.vue